import { getConfig } from "../config";
import { defaultOperators } from "react-querybuilder";
import { format } from "date-fns";

let appConfig = await getConfig();

export function TrackRecordModel(appBusinessUnit){
  let trackRecordJson = null;
  if (appBusinessUnit && appBusinessUnit === "Credit"){
    trackRecordJson = appConfig.CREDIT_INITIAL_QUERY
  }else {
    trackRecordJson = appConfig.PE_INITIAL_QUERY
  }
  return {
    trackRecordId: null,
    trackRecordName: "",
    trackRecordJson: trackRecordJson,
    trackRecordSql: "(1 = 1)",
    trackRecordAggregateBy: [],
    appBusinessUnit: "",
    trackRecordType: "",
    username: ""
  }
}

export function NewTrackRecord(appBusinessUnit) {
  return { ...TrackRecordModel(appBusinessUnit) };
}

export async function GetTrackRecordList(appBusinessUnit, isCashflow) {
  try {
    let url = appConfig.API_BASE_URL + "/queries?";
    const params = new URLSearchParams({
      business_unit: appBusinessUnit,
      username: sessionStorage.getItem("Username"),
      query_type: isCashflow ? "Cashflow" : "ROA"
    });
    const response = await fetch(url + params, {
      method: "get",
    });
    const data = await response.json();

    return data.map((trackRecord) => {
      let parsed_trackRecord = { ...TrackRecordModel };
      parsed_trackRecord.trackRecordId = trackRecord.Query_Id;
      parsed_trackRecord.trackRecordName = trackRecord.Query_Name;
      parsed_trackRecord.trackRecordJson = trackRecord.Query_Value;
      parsed_trackRecord.trackRecordSql = trackRecord.Query_Raw_Value;
      parsed_trackRecord.trackRecordAggregateBy = trackRecord.Aggregate_By;
      parsed_trackRecord.username = trackRecord.Username;
      parsed_trackRecord.trackRecordType = trackRecord.Query_Type;
      parsed_trackRecord.appBusinessUnit = trackRecord.Business_Unit

      return parsed_trackRecord;
    });
  } catch (error) {
    console.log(error);
    return;
  }
}

export async function SaveTrackRecord(trackRecord) {
  let url = appConfig.API_BASE_URL + "/queries";
  if (trackRecord.trackRecordId) {
    url = url + "/" + trackRecord.trackRecordId;
  }
  const requestOptions = {
    method: trackRecord.trackRecordId ? "PUT" : "POST", 
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      query_name: trackRecord.trackRecordName,
      business_unit: trackRecord.appBusinessUnit,
      query_filter: JSON.stringify(trackRecord.trackRecordJson),
      query_raw_filter: trackRecord.trackRecordSql,
      aggregate_by: JSON.stringify(trackRecord.trackRecordAggregateBy),
      is_deleted: 0,
      username: sessionStorage.getItem("Username"),
      query_type: trackRecord.trackRecordType
    }),
  };
  try {
    return await fetch(url, requestOptions);
  } catch (error) {
    console.log(error);
    return;
  }
} 

export async function deleteTrackRecord(trackRecord) {
  let url = appConfig.API_BASE_URL + "/queries";
  if (!trackRecord.trackRecordId) return;

  url = url + "/" + trackRecord.trackRecordId;

  const requestOptions = {
    method: "DELETE", 
    headers: {
      "Content-Type": "application/json",
      "username": sessionStorage.getItem("Username")
    },
  };
  try {
    return await fetch(url, requestOptions);
  } catch (error) {
    console.log(error);
    return;
  }
}

export async function GetAggregateData(
  sql_query,
  start_date,
  end_date,
  reporting_currency,
  fx_type,
  excludeFxForwards,
  excludeShorts,
  includeVP,
  overrideDate,
  business_unit,
  correlation_token_id,
  aggregate_by,
  controller,
  isCashflow
) {

  const url = isCashflow
    ? appConfig.API_BASE_URL + "/get_aggregate_data_cashflow?"
    : appConfig.API_BASE_URL + "/get_aggregate_data?";

  const params = new URLSearchParams({
    sql_query,
    start_date: format(start_date, "yyyy-MM-dd"),
    end_date: format(end_date, "yyyy-MM-dd"),
    reporting_currency,
    correlation_token: correlation_token_id,
    user_id: 111,
  });

  // Include roa-specific fields
  if (!isCashflow) {
    params.append("aggregate_by", aggregate_by);
    params.append("business_unit", business_unit);
  }

  // Include cashflow-specific fields
  if (isCashflow) {
    if (fx_type && appConfig.CASHFLOW_FX_TYPE_MAP[fx_type]) {
      params.append("fx_type", appConfig.CASHFLOW_FX_TYPE_MAP[fx_type]);
    }

    params.append("exclude_fx_forwards", excludeFxForwards ? "1" : "0");
    params.append("exclude_shorts", excludeShorts ? "1" : "0");
    params.append("vp_mode", includeVP ? "1" : "0");
    if (overrideDate && fx_type === 'Specific Date') {
      params.append("override_date", format(overrideDate, "yyyy-MM-dd"));
    }
  }

  const options = {
    method: "GET",
    signal: controller.signal,
  };

  const response = await fetch(url + params.toString(), options);
  const result = await response.json();
  if (!response.ok) {
    const error = new Error(result.message || response.statusText);
    error.errorType = result.error_type || null;
    error.detail = result.detail || null;
    error.statusCode = response.status;
    throw error;
  }
  return result;
}

async function handle_response(response) {
  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = { message: text };
    }
  }
  if (!response.ok) {
    const error = new Error(
      data?.message || response.statusText || "Request failed"
    );
    if (data && typeof data === "object" && !Array.isArray(data)) {
      error.errorType = data.error_type || null;
      error.detail = data.detail || null;
    }
    error.statusCode = response.status;
    throw error;
  }
  return data;
}

export async function GetFieldsWithValues(appBusinessUnit) {
  let url = appConfig.API_BASE_URL + "/query-builder-fields?";

  const selectedOperators = ["in", "notIn", "contains", "doesNotContain", "doesNotBeginWith", "doesNotEndWith", "beginsWith", "endsWith", "=", "!="];

  const options = {
    method: "GET",
  };

  const params = new URLSearchParams({
    business_unit: appBusinessUnit
  });

  return fetch(url + params, options).then(response => {
    return handle_response(response);
  }).then(data => {
    let result = data.map((g) => {
    return {
      ...g,
      options: g.options.map((i) =>
        i.values === undefined
          ? { ...i, name: `${i.label}` }
          : {
            ...i,
            operators: defaultOperators.filter((op) =>
              selectedOperators.includes(op.name)
            ),
            name: i.name !== undefined ? `${i.name}` : `${i.label}`,
          }
      ),
    };
  });

    result = result.map((i) =>
        i.label === "Time"
            ? {
              ...i,
              options: i.options.map((j) => j.name === "AsOf_Date" || j.name === "As Of Date" ? { ...j, operators: defaultOperators.filter((op) => op.name === "between") } : j)
            }
            : i
    );
    return Promise.resolve(result)
  }).catch(error => {
    return Promise.reject(error)
  })
}

export async function GetFieldsWithValuesCashflows(appBusinessUnit) {
  let url = appConfig.API_BASE_URL + "/query-builder-fields-cashflow?";

  const selectedOperators = ["in", "notIn", "contains", "doesNotContain", "doesNotBeginWith", "doesNotEndWith", "beginsWith", "endsWith", "=", "!="];

  const options = {
    method: "GET",
  };

  const params = new URLSearchParams({
    business_unit: appBusinessUnit
  });

  return fetch(url + params, options)
    .then(response => handle_response(response))
    .then(data => {
      let result = data.map((group) => {
        return {
          ...group,
          options: group.options.map((field) =>
            field.values === undefined
              ? { ...field, name: `${field.label}` }
              : {
                  ...field,
                  operators: defaultOperators.filter((op) =>
                    selectedOperators.includes(op.name)
                  ),
                  name: field.name !== undefined ? `${field.name}` : `${field.label}`,
                }
          ),
        };
      });

      result = result.map((group) =>
        group.label === "Cashflow"
          ? {
              ...group,
              options: group.options.map((field) =>
                field.name === "Effective Date"
                  ? {
                      ...field,
                      operators: defaultOperators.filter(op => op.name === "between")
                    }
                  : field
              )
            }
          : group
      );

      return Promise.resolve(result);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export async function GetAggregateByFields(appBusinessUnit) {
  let url = appConfig.API_BASE_URL + "/aggregateby-fields?";
  const options = {
    method: "GET",
  };
  const params = new URLSearchParams({
    business_unit: appBusinessUnit
  });
  return fetch(url + params, options).then(response => {
    return handle_response(response);
  }).then(data => {
    return Promise.resolve(data);
  }).catch(error => {
    return Promise.reject(error);
  })
}

export async function GetFullDataFile(correlation_token, isCashflow) {
  let url = isCashflow 
    ? appConfig.API_BASE_URL + "/get_full_data_file_cashflow?"
    : appConfig.API_BASE_URL + "/get_full_data_file?";

  const params = new URLSearchParams({
    correlation_token: correlation_token,
    user_id: 111
  });
  const options = {
    method: "GET"
  };
  const response = await fetch(url + params, options);
  return response.blob();
}
